export default __webpack_public_path__ + "static/media/ping-alert2.92e101f8.wav";